import { AlarmPriority } from 'shared/components/alarm-card/enums/alarm-priority';

const getPriorityColor = (priority: AlarmPriority): string => {
  switch (priority) {
    case AlarmPriority.Highest:
      return 'highestPriority';
    case AlarmPriority.High:
      return 'highPriority';
    case AlarmPriority.Medium:
      return 'mediumPriority';
    default:
      return 'defaultPriority';
  }
};

export default getPriorityColor;
